import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { AreasStore } from 'app/core/areas/areas.store';
import { getProperties } from 'app/core/properties-table/properties.reducer';
import { saveParcelsToFolder } from 'app/core/saved-properties/saved-properties.actions';
import { SharedModule } from 'app/shared';
import { Resource } from 'app/shared/acl/acl.model';
import { ModalsService } from 'app/shared/ui/modals/modals.service';
import { map } from 'rxjs';
import { FeatureSubscriptionModalComponent } from './feature-subscription.modal';


@Component({
    selector: 'new-notification-menu',
    imports: [
        SharedModule,
    ],
    template: `
        <ui-dropdown-menu placement="right">
            <button
                *apAcl="[r.NOTIF_FOLDER_PI, r.NOTIF_FOLDER_BL]"
                class="dropdown-item border-0"
                [disabled]="selectedParcels().length === 0"
                (click)="saveSelected()"
                tooltip="Please select properties on the map before saving"
                tooltipPlacement="left"
                [tooltipDisabled]="selectedParcels().length > 0">
                Save Selected ({{ selectedParcels().length }})
            </button>
            <button
                *apAcl="[r.NOTIF_AREA_PI, r.NOTIF_AREA_BL, r.NOTIF_AREA_MLS]"
                class="dropdown-item border-0"
                (click)="drawBoundary()">
                Draw a Boundary
            </button>
            <button
                *apAcl="[r.NOTIF_AREA_PI, r.NOTIF_AREA_BL, r.NOTIF_AREA_MLS]"
                class="dropdown-item border-0"
                (click)="selectArea()">
                Select an Area from a List
            </button>
        </ui-dropdown-menu>
    `,
})
export class NewNotificationMenuComponent {

    r = Resource;

    private store = inject(Store);

    private areasStore = inject(AreasStore);

    selectedParcels = toSignal(this.store.select(getProperties).pipe(map(items => items.map(i => i.parcel))), { requireSync: true });

    saveSelected() {
        this.store.dispatch(saveParcelsToFolder({ parcels: this.selectedParcels() }));
    }

    drawBoundary() {
        this.areasStore.drawBoundary();
    }

    selectArea() {
        this.areasStore.selectArea();
    }
}


@Component({
    selector: 'new-notification-button',
    imports: [
        SharedModule,
    ],
    styles: [
        `
        .lock-icon {
            margin: -4px -8px -4px 0;
        }
        `
    ],
    template: `
        <ng-container *apAcl="r.UPGRADE_NOTIF; behavior: 'always-show'; let lockIcon = granted">
            @if (lockIcon) {
                <div class="d-flex align-items-center">
                    <button [class]="classes()" (click)="openSubscriptions()">
                        + New Notification
                        <img alt="" src="/assets/images/skills-centre/lock.svg" class="lock-icon">
                    </button>
                </div>
            }
            @else {
                <div class="d-flex align-items-center" [uiDropdown]="menuComponent">
                    <button [class]="classes()" [dropdownToggle]="true">
                        + New Notification
                    </button>
                </div>
            }
        </ng-container>
    `,
})
export class NewNotificationButtonComponent {

    r = Resource;

    classes = input('btn btn-primary');

    menuComponent = NewNotificationMenuComponent;

    private modalsService = inject(ModalsService);

    openSubscriptions() {
        this.modalsService.openModal(FeatureSubscriptionModalComponent);
    }
}
